import React from 'react';
import { X } from 'lucide-react';

const Modal = ({ isOpen, onClose, onGoToCompetition }) => {
  if (!isOpen) return null;

  const handleUnderstand = () => {
    onClose();
    onGoToCompetition();
  };

  return (
    <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'>
      <div className='bg-white rounded-lg p-8 max-w-md mx-4 w-full'>
        <div className='flex justify-end mb-4'>
          <button
            onClick={onClose}
            className='text-gray-400 hover:text-gray-600 transition-colors duration-200'
          >
            <X size={24} />
          </button>
        </div>

        <div className='text-center'>
          <h2 className='text-xl font-bold text-gray-900 mb-4'>
            Student Competitions 2025 — Notice
          </h2>

          <div className='text-left mb-6'>
            <p className='text-red-600 mb-2'>
              This competition is currently in testing (beta).
            </p>
            <p className='text-red-600 mb-2'>
              Some website features are still under development and will be
              released gradually.
            </p>
            <p className='text-gray-700 mb-2'>
              If you have any questions, please email:{' '}
              <a
                href='mailto:tag@rainwang.art'
                className='text-blue-600 hover:underline'
              >
                tag@rainwang.art
              </a>
            </p>
          </div>

          <div className='border-t pt-4 mb-6'>
            <p className='text-gray-700 text-right'>
              Founder of TAG — Rain Wang
            </p>
          </div>

          <button
            onClick={handleUnderstand}
            className='bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors duration-200'
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
